<template>
  <div id="signature-container">
    <div id="signature" tabindex="0"></div>
    <div class="clear">
      <span class="signature-clear" @click="onClickClear">[clear]</span>
    </div>
    <div class="signature-support">
      Use your mouse or finger to draw your signature above
    </div>
  </div>
</template>

<script>
export default {
  name: 'jsignature',
  props: {
  },
  data (){
    return {
    }
  },
  mounted(){
    var self = this;
    var settings = {
      width: '100%',
      height: 200
    };

    this.sigDiv = $(this.$el.children[0]).jSignature(settings);
    this.sigDiv.bind("change", function(event) {
      var data = self.sigDiv.jSignature("getData", "native");
      if(!data.length) {
        self.$emit("change-signature", null);
        return;
      }

      var formattedData = self.sigDiv.jSignature("getData", "default");
      self.$emit("change-signature", formattedData);
    });
  },
  methods: {
    onClickUndo(){
      var data = this.sigDiv.jSignature("getData", "native");
      var newData = [];

      if(!data.length){
        return;
      }

      if(data.length == 1){
        this.sigDiv.jSignature("reset");
        return;
      }

      for (let i=0; i < data.length - 1; i++){
        newData.push(data[i]);
      }

      this.sigDiv.jSignature("setData", newData, "native");
    },

    onClickClear(){
      this.sigDiv.jSignature("clear");
      this.$emit("clear");
    }
  }
}
</script>
<style scoped>
div {
  margin-top:1em;
  margin-bottom:1em;
}
input {
  padding: .5em;
  margin: .5em;
}
select {
  padding: .5em;
  margin: .5em;
}

#signature-container {
  /*max-width:600px;*/
  padding: 0;
}

/*This is the div within which the signature canvas is fitted*/
#signature {
  margin: 0;
  color:darkblue;
  border: 2px dotted black;
  background-color:lightgrey;
}

.clear{
  text-align: right;
  margin: 0;
}
/*Set cursor*/
.signature-clear{
  cursor: pointer;
}

.signature-support{
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 12px;
  color: #595d64;
  margin-top: 0px;
  clear: both;
}

/* On mobile the shared page css bumps .signature-support to 26px while
   this component's 12px line-height and 0 top margin still apply, so the
   lines overlap and the text hugs the [clear] link above it. */
@media only screen and (max-width: 1280px) {
  .signature-support {
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 1.4 !important;
  }
}

/* Drawing the 'gripper' for touch-enabled devices */ 
html.touch #content {
  float:left;
  width:92%;
}
html.touch #scrollgrabber {
  float:right;
  width:4%;
  margin-right:2%;
  background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAFCAAAAACh79lDAAAAAXNSR0IArs4c6QAAABJJREFUCB1jmMmQxjCT4T/DfwAPLgOXlrt3IwAAAABJRU5ErkJggg==)
}
html.borderradius #scrollgrabber {
  border-radius: 1em;
}
/* 
.signature-container{
  border: 1px solid #cfd4d8;
  border-radius: 0;
  background-color: #fff;
  transition-timing-function: ease-in-out;
  transition-duration: 0s;
  transition-property: color,background-color,border,border-color,box-shadow;
} */

</style>
